export default "__VITE_ASSET__407f9e1d__"